import React, { useState } from 'react';
import { Plus, Edit, Trash2, FileText } from 'lucide-react';

const ExamType = () => {
  const [examTypes, setExamTypes] = useState([
    { id: 1, name: 'Mid-term', description: 'Mid-semester examination', weightage: 30 },
    { id: 2, name: 'Final', description: 'Final semester examination', weightage: 50 },
    { id: 3, name: 'Unit Test', description: 'Regular unit tests', weightage: 10 },
    { id: 4, name: 'Assignment', description: 'Course assignments', weightage: 5 },
    { id: 5, name: 'Practical', description: 'Practical examinations', weightage: 5 }
  ]);
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Exam Type</h1>
          <p className="text-sm text-gray-500 mt-1">Manage examination types and weightage</p>
        </div>
        <button onClick={() => setShowModal(true)} className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
          <Plus className="h-4 w-4" />
          Add Exam Type
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Total Types</p>
              <p className="text-3xl font-bold text-gray-900 mt-1">{examTypes.length}</p>
            </div>
            <FileText className="h-12 w-12 text-blue-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Total Weightage</p>
              <p className="text-3xl font-bold text-green-600 mt-1">{examTypes.reduce((sum, type) => sum + type.weightage, 0)}%</p>
            </div>
            <FileText className="h-12 w-12 text-green-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Active Types</p>
              <p className="text-3xl font-bold text-purple-600 mt-1">{examTypes.length}</p>
            </div>
            <FileText className="h-12 w-12 text-purple-500" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Exam Type</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Description</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Weightage (%)</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {examTypes.map((type) => (
              <tr key={type.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-sm font-medium text-gray-900">{type.name}</td>
                <td className="px-6 py-4 text-sm text-gray-500">{type.description}</td>
                <td className="px-6 py-4 text-center">
                  <span className="inline-flex px-3 py-1 text-sm font-semibold rounded-full bg-blue-100 text-blue-800">{type.weightage}%</span>
                </td>
                <td className="px-6 py-4 text-right">
                  <div className="flex justify-end gap-2">
                    <button className="text-blue-600 hover:text-blue-900"><Edit className="h-4 w-4" /></button>
                    <button className="text-red-600 hover:text-red-900"><Trash2 className="h-4 w-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExamType;